import EventClass from "common/utils/ui/event-class";
import "./digital-assets-dtf-buttons.scss";

export default props =>
  new EventClass({
    eventSelector: ".js-digital-assets-dtf-button",
    ...props
  });
